(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Hero adımları: görseller ve adım çubukları sırayla döner; ekran dışındayken durur.
  const initStage = (stage) => {
    const frames = [...stage.querySelectorAll('[data-cr-frame]')];
    const steps = [...stage.querySelectorAll('[data-cr-step]')];
    if (frames.length < 2 || reduceMotion) return;

    // Görsel adımlar sabit süre kalır; video adımları video bitene kadar kalır.
    const interval = Number(stage.dataset.interval) || 3000;
    let index = 0;
    let timer = null;
    let running = false;

    const videoOf = (frame) => frame.querySelector('video');

    const play = () => {
      clearTimeout(timer);
      const video = videoOf(frames[index]);
      let duration = interval;
      if (video) {
        video.currentTime = 0;
        video.play().catch(() => {});
        if (video.duration) duration = video.duration * 1000;
        video.onended = () => running && advance();
      }
      stage.style.setProperty('--cr-step', `${duration}ms`);
      // Çubuk animasyonunu yeniden başlat.
      steps[index]?.classList.remove('is-active');
      void stage.offsetWidth;
      steps[index]?.classList.add('is-active');
      // Video oynatılamazsa da döngü takılmasın diye yedek zamanlayıcı.
      const wait = video ? (video.duration ? duration + 1500 : 10000) : duration;
      timer = setTimeout(() => running && advance(), wait);
    };

    const show = (next) => {
      const previous = videoOf(frames[index]);
      if (previous) previous.pause();
      frames[index].classList.remove('is-active');
      frames[next].classList.add('is-active');
      steps.forEach((step, i) => {
        step.classList.toggle('is-active', i === next);
        step.classList.toggle('is-done', i < next);
      });
      index = next;
    };

    const advance = () => {
      show((index + 1) % frames.length);
      play();
    };

    const start = () => {
      if (running) return;
      running = true;
      play();
    };
    const stop = () => {
      running = false;
      clearTimeout(timer);
      const video = videoOf(frames[index]);
      if (video) video.pause();
    };

    new IntersectionObserver(([entry]) => (entry.isIntersecting ? start() : stop()), { threshold: 0.2 }).observe(stage);
  };

  // Bölüm içerikleri ekrana girerken yumuşakça belirir.
  const REVEAL = '.cr-section-head, .cr-card, .cr-trust__item, .cr-offer__card, .cr-faq details, .cr-compare table, .cr-paper__col';
  const initReveal = (root) => {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
    root.querySelectorAll(REVEAL).forEach((el) => {
      if (el.closest('.cr-hm') || el.classList.contains('cr-reveal')) return;
      const position = [...el.parentElement.children].indexOf(el);
      el.style.setProperty('--cr-delay', `${Math.min(position, 4) * 0.08}s`);
      el.classList.add('cr-reveal');
      observer.observe(el);
    });
  };

  // Kâğıt havlu karşılaştırması: kareler dolar, sayı sıfırdan sayar.
  const initCounter = (dots) => {
    const counter = dots.closest('.cr-paper__side')?.querySelector('[data-cr-count]');
    if (reduceMotion) {
      dots.classList.add('is-filled');
      return;
    }
    new IntersectionObserver(
      ([entry], observer) => {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        dots.classList.add('is-filled');
        if (!counter) return;
        const target = Number(counter.dataset.crCount);
        const start = performance.now();
        const tick = (now) => {
          const progress = Math.min((now - start) / 1400, 1);
          counter.textContent = Math.round(target * (1 - Math.pow(1 - progress, 3)));
          if (progress < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      },
      { threshold: 0.4 }
    ).observe(dots);
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-cr-stage]').forEach(initStage);
    root.querySelectorAll('[data-cr-dots]').forEach(initCounter);
    initReveal(root);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  // Tema düzenleyicisinde bölüm yeniden yüklendiğinde tekrar başlat.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
